import { render, staticRenderFns } from "./GiftVoucher.vue?vue&type=template&id=1dc62210&scoped=true&"
import script from "./GiftVoucher.vue?vue&type=script&lang=js&"
export * from "./GiftVoucher.vue?vue&type=script&lang=js&"
import style0 from "./GiftVoucher.vue?vue&type=style&index=0&id=1dc62210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc62210",
  null
  
)

export default component.exports